export const DEFAULT_PAGE_SIZE = 20;

export type PaginationRequest = {
  page?: number;
  pageSize?: number;
};

export type NormalizedPagination = {
  page: number;
  pageSize: number;
  pageApi: number;
};

export const getPaginationParams = (
  request?: PaginationRequest | null,
  defaultPageSize: number = DEFAULT_PAGE_SIZE
): NormalizedPagination => {
  const page = request?.page ?? 0;
  const pageSize = request?.pageSize ?? defaultPageSize;
  return {
    page,
    pageSize,
    pageApi: page + 1
  };
};

export const toOptionalApiPaginationParams = (
  request?: PaginationRequest | null,
  defaultPageSize: number = DEFAULT_PAGE_SIZE
): { page: number; pageSize: number } | undefined => {
  if (request == null) {
    return undefined;
  }

  return {
    page: request.page ?? 1,
    pageSize: request.pageSize ?? defaultPageSize
  };
};
